import { render, staticRenderFns } from "./AppointmentReason.vue?vue&type=template&id=4460be49&scoped=true"
import script from "./AppointmentReason.vue?vue&type=script&lang=js"
export * from "./AppointmentReason.vue?vue&type=script&lang=js"
import style0 from "./AppointmentReason.vue?vue&type=style&index=0&id=4460be49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4460be49",
  null
  
)

export default component.exports